import { useCallback, useEffect, useRef, useState } from 'react';

export type ExportProgress = { done: number; total: number };

/**
 * 엑셀 수집 회차의 진행 상태.
 * - 컴포넌트 생존(alive)과 화면 활성(알림 여부)을 구분한다. 진행 상태는 **생존 여부만** 보고 정리한다 —
 *   KeepAlive 로 다른 메뉴에 가 있는 동안 끝난 회차도 진행 표시를 지워, 돌아왔을 때 버튼이 잠겨 있지 않게.
 * - 회차 id 로 비교해, 끝난 옛 회차가 그 사이 새로 시작한 회차의 진행 표시를 지우지 않는다.
 */
export const useExportRun = () => {
    const [progress, setProgress] = useState<ExportProgress | null>(null);
    const runId = useRef(0);
    const alive = useRef(true);
    useEffect(() => {
        alive.current = true;
        return () => {
            alive.current = false;
        };
    }, []);

    const begin = useCallback((total: number) => {
        runId.current += 1;
        const id = runId.current;
        setProgress({ done: 0, total });
        return id;
    }, []);
    const update = useCallback((id: number, done: number, total: number) => {
        if (alive.current && id === runId.current) setProgress({ done, total });
    }, []);
    const finish = useCallback((id: number) => {
        if (alive.current && id === runId.current) setProgress(null);
    }, []);

    return { progress, begin, update, finish };
};
